import { React } from '@digsup/core-ui';

export const StepsContext = React.createContext();
